import * as React from 'react';
import Draggable from '@telerik/kendo-draggable';
/** @hidden */
export function useDraggable(ref, _a) {
    var onPress = _a.onPress, onDrag = _a.onDrag, onRelease = _a.onRelease;
    var draggable = React.useMemo(function () { return new Draggable({
        press: onPress,
        drag: onDrag,
        release: onRelease
    }); }, []);
    var initDraggable = function () {
        var element = ref.current;
        if (!element) {
            return;
        }
        draggable.bindTo(element);
        return function () { draggable.destroy(); };
    };
    var updateDraggable = function () {
        draggable.update({
            press: onPress,
            drag: onDrag,
            release: onRelease
        });
    };
    React.useEffect(initDraggable, []);
    React.useEffect(updateDraggable, [onPress, onDrag, onRelease]);
}
//# sourceMappingURL=useDraggable.js.map